// eslint-disable-next-line import/no-anonymous-default-export
export default {
  profile: [
    {
      image: "https://engineering.unl.edu/images/staff/Kayla-Person.jpg",
      name: "Filza",
      age: 20,
      gender: "female",
      state: "Punjab",
      city: "Lahore",
      country: "Pakistan",
      zipCode: "123",
      emal: "filza@gmail.com",
      phone: "123",
      about:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut quibusdam ipsum ab dolore dolores repellendus. Eos reiciendis ratione totam nostrum.",
      skillLevel: "Beginner",
      currentHandicap: "10",
      oftenPlay: "once a week",
      availability: "morning",
      distance: "10",
      purpose: "I just want to play",
      matirialStatus: "single",
      drinker: "yes",
      linkdinProfile: "ahah",
      companyName: "Abcbc",
      positionInCompany: "Employee",
      industry: "Entertainment",
      smoker: "Cigerete Vape Weed",
      race: "asian",
      religion: "Muslim",
      politicalView: "Liberal",
      favouriteCourse: "Sugar Hill Golf Club ",
    },
    {
      image:
        "https://upload.wikimedia.org/wikipedia/commons/a/a0/Pierre-Person.jpg",
      name: "Haseeb",
      age: 20,
      gender: "male",
      matirialStatus: "single",
    },
    {
      image:
        "https://upload.wikimedia.org/wikipedia/commons/a/a0/Pierre-Person.jpg",
      name: "Obaid",
      age: 22,
      gender: "male",
      matirialStatus: "single",
    },
    {
      image:
        "https://upload.wikimedia.org/wikipedia/commons/a/a0/Pierre-Person.jpg",
      name: "Sameer",
      age: 22,
      gender: "male",
      matirialStatus: "married",
    },
    {
      image:
        "https://upload.wikimedia.org/wikipedia/commons/a/a0/Pierre-Person.jpg",
      name: "Abdul",
      age: 22,
      gender: "male",
      matirialStatus: "single",
    },
  ],
  gender: [
    {
      value: "male",
    },
    {
      value: "female",
    },
  ],
  age: [
    {
      value: "18-25",
    },
    {
      value: "26-35",
    },
    {
      value: "36-45",
    },
    {
      value: "46-55",
    },
    {
      value: "56-65",
    },
    {
      value: "66-100",
    },
  ],
  materialStatus: [
    {
      value: "single",
    },
    {
      value: "married",
    },
    {
      value: "divorced",
    },
    {
      value: "widowed",
    },
  ],
  drinker: [
    {
      value: "yes",
    },
    {
      value: "no",
    },
  ],
  smoker: [
    {
      value: "No",
    },
    {
      value: "Cigarettes",
    },
    {
      value: "Cigar",
    },
    {
      value: "Vape",
    },
    {
      value: "Other",
    },
  ],
  race: [
    {
      value: "white",
    },
    {
      value: "black",
    },
    {
      value: "asian",
    },
    {
      value: "hispanic",
    },
    {
      value: "mixed",
    },
    {
      value: "american Indian/Alaska Native",
    },
    {
      value: "Native Hawaiian/Other Islander",
    },
  ],
  religion: [
    {
      value: "christian",
    },
    {
      value: "catholic",
    },
    {
      value: "mormon",
    },
    {
      value: "unaffiliated",
    },
    {
      value: "atheist",
    },
    {
      value: "agnostic",
    },
    {
      value: "jewish",
    },
    {
      value: "hindu",
    },
    {
      value: "buddish",
    },
  ],
  politicalView: [
    {
      value: "conservative",
    },
    {
      value: "libral",
    },
    {
      value: "independent",
    },
    {
      value: "non-political",
    },
  ],
  favouriteCourse: [
    {
      value: "Bears Best Atlanta",
    },
    {
      value: "Country Land Golf Courses",
    },
    {
      value: "Collins Hill Golf Club",
    },
    {
      value: "Chicopee Woods Golf Courses",
    },
    {
      value: "Chestatee Golf Club",
    },
    {
      value: "Echelon Golf Club",
    },

    {
      value: "Hampton Golf Village",
    },
    {
      value: "Lanier Islands Golf Courses",
    },
    {
      value: "River Pines Golf Courses",
    },
    {
      value: "Reunion Country Club",
    },
    {
      value: "Sugar Hill Golf Club",
    },
    {
      value: "Steel Canyon",
    },
    {
      value: "St Marlo Country Club",
    },
    {
      value: "Windermere Golf Club",
    },

    {
      value: "Woodlands Course at Chateau Elan Golf Club",
    },
  ],
  skillLevel: [
    {
      value: "beginner",
    },
    {
      value: "below average",
    },
    {
      value: "average",
    },
    {
      value: "above average",
    },
    {
      value: "advance",
    },
  ],

  oftenPlay: [
    {
      value: "Daily",
    },
    {
      value: "Once a week",
    },
    {
      value: "Twice a week",
    },
    {
      value: "Three times a week",
    },
    {
      value: "Not very often",
    },
  ],
  availability: [
    {
      value: "Weekdays",
    },

    {
      value: "Weekends",
    },
    {
      value: "Mornings",
    },
    {
      value: "Mid-day",
    },
    {
      value: "Afternoons",
    },
    {
      value: "Anytime",
    },
  ],
  myAvailability: [
    {
      value: "sunday",
    },
    {
      value: "monday",
    },
    {
      value: "tuesday",
    },
    {
      value: "wednessday",
    },
    {
      value: "thursday",
    },
    {
      value: "friday",
    },
    {
      value: "saturday",
    },
    {
      value: "Anytime",
    },
  ],
  days: [
    {
      value: "sunday",
    },
    {
      value: "monday",
    },
    {
      value: "tuesday",
    },
    {
      value: "wednessday",
    },
    {
      value: "thursday",
    },
    {
      value: "friday",
    },
    {
      value: "saturday",
    },
  ],
  time: [
    {
      value: "morning",
    },
    {
      value: "mid-afternoon",
    },
    {
      value: "afternoon",
    },
    {
      value: "anytime",
    },
  ],
  distance: [
    {
      value: "0-10",
    },
    {
      value: "11-25",
    },
    {
      value: "26-50",
    },
    {
      value: "Any distance",
    },
  ],
  purpose: [
    {
      value: "I just want to play golf",
    },
    {
      value: "Meet new friends",
    },
    {
      value: "Dating",
    },
    {
      value: "Networking",
    },
  ],
  industry: [
    {
      value: "advertising and marketing",
    },
    {
      value: "aerospace",
    },
    {
      value: "agriculture",
    },
    {
      value: "computer technology",
    },
    {
      value: "construction",
    },
    {
      value: "education",
    },
    {
      value: "energy",
    },
    {
      value: "entertainment",
    },
    {
      value: "fashion",
    },
    {
      value: "finance economic",
    },
    {
      value: "food and beverage",
    },
    {
      value: "government",
    },
    {
      value: "healthcare",
    },
    {
      value: "hospitality",
    },
    {
      value: "manufacturing",
    },
    {
      value: "Media news",
    },
    {
      value: "mining",
    },
    {
      value: "pharmaceutical",
    },
    {
      value: "telecommunication",
    },
    {
      value: "transportation",
    },
  ],
  currentHandicap: [
    {
      name: "0 to 9",
      value: "0-9",
    },
    {
      name: "10 to 15",
      value: "10-15",
    },
    {
      name: "16 to 20",
      value: "16-20",
    },
    {
      name: "21 or 40",
      value: "21-40",
    },
    {
      name: "No Handicap",
      value: "0",
    },
  ],
  professional: [
    {
      value: "network",
    },
    {
      value: "looking for a job",
    },
    {
      value: "looking for a change careers",
    },
  ],
};
